export const REQUEST_CONFIG = {
  cacheTime: 1000 * 60 * 60 * 1, // 1 hour
  staleTime: 1000 * 60 * 60 * 1, // 1 hour
  retry: 1
}
